import type { Components } from '@mui/material/styles';

export default function MuiToolbar(): Components['MuiToolbar'] {
  return {};
}
